module.exports = __webpack_public_path__ + "static/media/burberry-body-big.bd2f6c12.png";